module.exports = __webpack_public_path__ + "portal-static/img/openroom.0a786098.png";